import { render } from "./ProjectCanvasContent.vue?vue&type=template&id=8e46c28a&scoped=true"
import script from "./ProjectCanvasContent.vue?vue&type=script&lang=js"
export * from "./ProjectCanvasContent.vue?vue&type=script&lang=js"

import "./ProjectCanvasContent.vue?vue&type=style&index=0&id=8e46c28a&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e46c28a"]])

export default __exports__